import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Vue from 'vue'

const state = {
	active: false,
  // model
  serviceModel: []
}

const getters = {
	get: state => state
}

const actions = {
	show ({commit}) {
		// cover
		this.dispatch('core/showModalCover')
		
		commit('showed')
	},
	hide ({commit}) {
		if (!state.active) return
		commit('hided')
		
		// cover
		setTimeout(() => {
			this.dispatch('core/hideModalCover')
		}, 350)
	},
  /**
   * 初期データを読出し
   */
  loadModel ({commit}, {serviceParams}) {
    return new Promise((resolve, reject) => {
      ApiManager.request(
        ['service'],
        ['v1ServiceListGet'],
        [serviceParams])
        .then(res => {
          let status = Utility.parseResponse(res)

          if (status.result) {
            commit('setServiceModel', res[0].data.serviceInfo)
            console.log('serviceModel', state.serviceModel)
            resolve()

          } else if (status.error) {
            // エラーメッセージ表示
            reject(res)
          } else {
            // アプリケーションエラー表示
            reject(null)
          }
        })
        .catch(error => {
          // アプリケーションエラー表示
          reject(null)
        })
    })
  }
}

const mutations = {
	showed (state) {
		state.active = true
	},
	hided (state) {
    state.active = false
	},
  setServiceModel (state, data) {
    // data.sort(Utility.sortByKey('CreatedAt', false))
    Vue.set(state, 'serviceModel', data)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
